import { useEffect } from 'react';
import { Container, Card, Button, Spinner, Alert } from 'react-bootstrap';
import './PrevRegistrationManagement.css';
import { useForm } from 'react-hook-form';
import InputField from '../InputField';
import { usePreviousMatchOTP } from '../apiEndpoints/commApiEndpoints';
import ResendOTP from './ResendOTP';
const OnlyRegistrationOTP = ({
  email,
  handleRegistration,
  type,
  setBack,
}: {
  email: string;
  handleRegistration: (value: boolean) => any;
  type: 'register_fair' | 'register_b2b' | 'register_visitor';
  setBack?: React.Dispatch<React.SetStateAction<boolean>>;
}) => {
  const {
    mutate: otpMutate,
    isSuccess: matchSuc,
    isPending: matchPending,
  } = usePreviousMatchOTP();
  const { register, handleSubmit, reset } = useForm();

  const onSubmit = async (value: any) => {
    otpMutate({ email, type: type, otp: value?.otp?.trim() });
  };

  useEffect(() => {
    if (matchSuc) {
      handleRegistration(matchSuc);
      reset();
    }
  }, [matchSuc]);
  return (
    <Container className='registration-check-container'>
      <div className='registration-check-card-wrapper'>
        <Card className='registration-check-card'>
          <Card.Body>
            <Alert variant={'success'}>
              We sent a 6-digit OTP code to your email !
            </Alert>
            <form onSubmit={handleSubmit(onSubmit)}>
              <InputField
                label='OTP Code'
                register={register('otp')}
                type='number'
                isRequired
                placeholder='Enter OTP Code'
              />

              <Button
                variant='primary'
                type='submit'
                className='w-100 mt-3 submit-btn'
                disabled={matchPending}
              >
                {matchPending ? (
                  <Spinner
                    as='span'
                    animation='border'
                    size='sm'
                    role='status'
                    aria-hidden='true'
                  />
                ) : (
                  'Submit'
                )}
              </Button>

              <ResendOTP setBack={setBack} email={email} type={type} />
            </form>
          </Card.Body>
        </Card>
      </div>
    </Container>
  );
};

export default OnlyRegistrationOTP;
